import React, { useState } from 'react';
import { HotelPageResponse, Rate } from '../../../backend/src/models/rateHawkModels/hotelPageResponseModel';
import { format } from 'date-fns';
import { useHotelContext } from '../contexts/HotelContext';
import { preBookHotel } from '../api-client';
import Swal from 'sweetalert2';
import PageLoaderComponent from './Common/PageLoader';
import { useSearchContext } from '../contexts/SearchContext';
import RoomImageGallery from './RoomImageGallery';

interface RoomsAndPriceProps {
  rates: Rate[];
  hotelName: string;
  slug: string;
  hotelId: string;
  totalCount: number;
  rate: number;
  hotel: HotelPageResponse;
  roomName: string;
  minPrice: number;
  //mealPlans: string[];
  hotelDataInfo: any;
  onSelectRoom: (room: Rate) => void;
}

const RoomsAndPrice: React.FC<RoomsAndPriceProps> = ({
  rates,
  // onSelectRoom,
  hotelName,
  hotelId,
  roomName,
  hotelDataInfo,
}) => {
  // const [isExpanded, setIsExpanded] = useState(false);
  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const { matchRoom, saveHotelValues } = useHotelContext();
  // const [selectedRate, setSelectedRate] = useState<Rate | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const search = useSearchContext();

  const toggleRowExpand = (roomName: string) => {
    setExpandedRow(expandedRow === roomName ? null : roomName);
  };

  // const toggleExpand = () => setIsExpanded(!isExpanded);

  const handleEnquire = async (rate: Rate) => {
    setIsLoading(true);
    try {
      const preBookResponse = await preBookHotel({
        hash: rate.book_hash,
        price_increase_percent: 0,
      });

      if (preBookResponse?.data.changes.price_changed === false) {
        const excludedTaxes =
          rate.payment_options.payment_types[0].tax_data?.taxes?.filter(
            (tax) => tax.included_by_supplier === false
          ) || [];
          const markedUpPrice = parseFloat(preBookResponse?.data.hotels[0].rates[0].payment_options.payment_types[0]?.amount || '0') * 1.15;
        saveHotelValues(
          //rate.book_hash,
          preBookResponse?.data.hotels[0].rates[0].book_hash,
          //rate.room_data_trans.main_name,
          preBookResponse?.data.hotels[0].rates[0].room_name,
          hotelName,
          //rate.meal_data.value,
          preBookResponse?.data.hotels[0].rates[0].meal_data.value,
          //rate.payment_options.payment_types[0].amount,
          markedUpPrice.toFixed(2).toString(),
          hotelId,
          //rate.payment_options.payment_types[0].amount,
          markedUpPrice.toFixed(2).toString(),
          //rate.payment_options.payment_types[0].cancellation_penalties,
          preBookResponse?.data.hotels[0].rates[0].payment_options.payment_types[0].cancellation_penalties,
          excludedTaxes,
          rate.match_hash
        );

        const isMobile = window.innerWidth < 768;

        setTimeout(() => {
          const elementId = isMobile ? 'inquire' : 'inquire2';
          const headerOffset = isMobile ? 140 : 50;

          const element = document.getElementById(elementId);
          if (element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      } else {
        Swal.fire({
          title: "Price has changed.",
          text: "Do you want to continue?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
          customClass: {
            popup: "custom-swal-popup",
            title: "custom-swal-title",
            htmlContainer: "custom-swal-text",
            confirmButton: "custom-swal-confirm",
            cancelButton: "custom-swal-cancel"
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            const excludedTaxes =
              rate.payment_options.payment_types[0].tax_data?.taxes?.filter(
                (tax) => tax.included_by_supplier === false
              ) || [];
            const markedUpPrice = parseFloat(preBookResponse?.data.hotels[0].rates[0].payment_options.payment_types[0]?.amount || '0') * 1.15;
            const markedUpPrice2 = parseFloat(rate.payment_options.payment_types[0].amount || '0') * 1.15;
            saveHotelValues(
              //rate.book_hash,
              preBookResponse?.data.hotels[0].rates[0].book_hash || '',
              //rate.room_data_trans.main_name,
              preBookResponse?.data.hotels[0].rates[0].room_name || '',
              hotelName,
              //rate.meal_data.value,
              preBookResponse?.data.hotels[0].rates[0].meal_data.value || '',
              markedUpPrice.toFixed(2).toString() ?? markedUpPrice2.toFixed(2).toString(),
              hotelId,
              markedUpPrice.toFixed(2).toString() ?? markedUpPrice2.toFixed(2).toString(),
              preBookResponse?.data.hotels[0].rates[0].payment_options.payment_types[0].cancellation_penalties ?? rate.payment_options.payment_types[0].cancellation_penalties,
              excludedTaxes,
              rate.match_hash || ''
            );
          }
        });
      }
    } catch (error) {
      console.error("Error during pre-booking:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <PageLoaderComponent
      location={hotelName}
      checkIn={search.checkIn.toString()}
      checkOut={search.checkOut.toString()}
    />;
  }

  // const handleRoomDetails = (deal: Rate) => {
  //   setSelectedRate(deal);
  //   onSelectRoom(rates[0]);
  // };

  // const ratesToShow = [rates];

  // const groupRatesByMealPlan = (rates: Rate[]) => {
  //   const grouped: Record<string, Rate> = {};

  //   rates.forEach((rate) => {
  //     const mealPlanKey = rate.meal_data.value.trim();

  //     // Keep only the lowest price for each meal plan
  //     if (!grouped[mealPlanKey] || parseFloat(rate.payment_options.payment_types[0].show_amount) < parseFloat(grouped[mealPlanKey].payment_options.payment_types[0].show_amount)) {
  //       grouped[mealPlanKey] = rate;
  //     }
  //   });

  //   return Object.values(grouped);
  // };

  const groupedRates = rates;
  
  
  const formatCancellationDate = (dateString: string | null) => {
    if (!dateString) return "Non-refundable";
  
    const date = new Date(dateString);
    return `Free Cancellation before ${format(date, "MMMM dd*")}`; // Example: "09 Oct 2025, 09:00 PM"
  };

  const cancellationDates = (dateString: string | null) => {
    if (!dateString) return "Non-refundable";
  
    const date = new Date(dateString);
    return `${format(date, "dd MMM yyyy, hh:mm a")}`; // Example: "09 Oct 2025, 09:00 PM"
  };

  // const getRoomImageByName = (roomName: string): string | null => {
  //   const roomGroup = hotelDataInfo.data.room_groups.find((group: { name_struct: { main_name: string; }; }) =>
  //     group.name_struct.main_name.toLowerCase().trim() === roomName.toLowerCase().trim()
  //   );
  
  //   if (roomGroup && roomGroup.images && roomGroup.images.length > 0) {
  //     return roomGroup.images[0].replace('{size}', '640x640');
  //   }
  
  //   return null;
  // };
  
  // const imageUrl = getRoomImageByName(roomName);

  // const matchedRoomGroup = hotelDataInfo?.data?.room_groups?.find(
  //   (group: { name_struct: { main_name: string; }; }) => group.name_struct.main_name.trim().toLowerCase() === roomName.trim().toLowerCase()
  // );
  // const matchedRoomGroup = hotelDataInfo?.data?.rg_ext?.find(
  //   (group: { name: string }) =>
  //     group.name.trim().toLowerCase() === roomName.trim().toLowerCase()
  // );

  const normalizeRgExt = (rg: any) => {
    const defaultKeys = [
      "class",
      "quality",
      "sex",
      "bathroom",
      "bedding",
      "family",
      "capacity",
      "club",
      "bedrooms",
      "balcony",
      "view",
      "floor",
    ];
    return defaultKeys.reduce((acc, key) => {
      acc[key] = rg?.[key] ?? 0; // default to 0 if undefined
      return acc;
    }, {} as Record<string, number>);
  };

  const isMatchingRgExt = (a: any, b: any): boolean => {
    const normA = normalizeRgExt(a);
    const normB = normalizeRgExt(b);

    return Object.keys(normA).every((key) => normA[key] === normB[key]);
  };

  const matchedRoomGroup = hotelDataInfo?.data?.room_groups?.find(
    (group: any) =>
      rates.some((rate) =>
      isMatchingRgExt(
        normalizeRgExt(group.rg_ext),
        normalizeRgExt(rate.rg_ext)
      )
    )
  );

  return (
    <>
      <div
        key={roomName}
        className="border border-gray-200 rounded-lg shadow-sm mb-4 md:mx-0 mx-4 overflow-hidden"
      >
        <div
          onClick={() => toggleRowExpand(roomName)}
          className={`p-2 border-b block md:flex justify-between items-center transition ${
            expandedRow === roomName
              ? "bg-halo-pink-bg"
              : "bg-white hover:bg-halo-pink-bg"
          }`}
        >
          <div className="flex items-center">
            {matchedRoomGroup?.images?.length > 0 ? (
              <RoomImageGallery images={matchedRoomGroup.images} />
            ) : (
              <div className="relative min-w-[128px] min-h-[96px] max-w-[128px] max-h-[96px] w-[128px] h-[96px] rounded-md overflow-hidden border mr-4 shrink-0">
                <img
                  src="/no-photo.png"
                  alt="No Room Available"
                  className="w-full h-full object-contain"
                />
                <div className="absolute bottom-1 left-1 bg-white bg-opacity-80 px-2 py-0.5 text-xs rounded shadow text-gray-700 font-medium">
                  No photos
                </div>
              </div>
            )}
            <div className='flex-1 min-w-0'>
              <h3 className="text-base font-semibold text-gray-800 cursor-pointer">
                {roomName}
              </h3>
              <span className="text-sm text-gray-500">
                From{" "}
                <span className="font-medium text-halo-pink">
                  £{" "}
                  {(parseFloat(groupedRates[0].payment_options.payment_types[0].amount) * 1.15).toFixed(2)}{" "}
                  {/* pp */}
                </span>
              </span>
            </div>
          </div>

          <div
            className="text-halo-pink text-sm cursor-pointer text-right whitespace-nowrap ml-4"
            onClick={() => toggleRowExpand(roomName)}
          >
            {expandedRow === roomName ? (
              <div className="flex items-center justify-end">
                See Less
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-chevron-up ml-2"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                  />
                </svg>
              </div>
            ) : (
              <div className="flex items-center justify-end text-sm">
                Select Meal Plan
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-chevron-down ml-2"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </div>
            )}
          </div>
        </div>

        {expandedRow === roomName && (
          <div className="md:py-4 md:px-4 py-4 px-2 bg-white">
            <div className="hidden lg:block">
              <table className="min-w-full border-collapse text-left text-base">
                <thead>
                  <tr className="border-b text-gray-600">
                    <th className="py-2 px-4">Meal Plan</th>
                    <th className="py-2 px-4">Price</th>
                    <th className="py-2 px-4">Cancellation Policy</th>
                    <th className="py-2 px-4">Options</th>
                  </tr>
                </thead>
                <tbody>
                  {groupedRates.map((rate, index) => (
                    <tr key={index} className="hover:bg-gray-50 text-sm">
                      <td className="py-3 px-4">
                        <span className="text-gray-600 font-medium">
                          {rate.meal_data.value.charAt(0).toUpperCase() + rate.meal_data.value.slice(1)}
                        </span>
                      </td>
                      <td className="py-3 px-4">
                        <span className="text-sm font-bold text-gray-800 whitespace-nowrap">
                          £ {(parseFloat(rate.payment_options.payment_types[0].amount) * 1.15).toFixed(2)}{" "}
                          {/* pp */}
                        </span>
                      </td>
                      <td className="py-3 px-4">
                        {/* <span className="text-sm text-green-600 mb-0 font-medium">
                            {rate.payment_options.payment_types[0].cancellation_penalties.free_cancellation_before != null
                              ? <span className="flex items-center">
                              {formatCancellationDate(rate.payment_options.payment_types[0].cancellation_penalties.free_cancellation_before)}
                              <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              fill="currentColor"
                              className="bi bi-info-circle cursor-pointer text-gray-500"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                            </svg>
                            </span>
                              : "Non-refundable"}
                          </span> */}

                        <div className="flex justify-between items-center">
                          <span className="relative flex items-center">
                            <div className="text-sm text-green-600">
                              {rate.payment_options.payment_types[0]
                                .cancellation_penalties
                                .free_cancellation_before != null ? (
                                <span className="flex items-center">
                                  {formatCancellationDate(
                                    rate.payment_options.payment_types[0]
                                      .cancellation_penalties
                                      .free_cancellation_before
                                  )}
                                </span>
                              ) : (
                                "Non-refundable"
                              )}
                            </div>
                            <span className="relative inline-flex ml-1 group">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                fill="currentColor"
                                className="bi bi-info-circle cursor-pointer text-gray-500"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                              </svg>
                              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-[250px] mb-2 hidden group-hover:block p-3 bg-gray-800 text-white text-xs rounded-lg shadow-md text-center">
                                {
                                  <>
                                    <div>Cancellation Policy</div>
                                    {rate.payment_options.payment_types[0].cancellation_penalties.policies.map(
                                      (policy, index) => (
                                        <div key={index} className="mt-2">
                                          {policy.start_at === null &&
                                          policy.end_at !== null
                                            ? `Free cancellation at this rate until ${cancellationDates(
                                                policy.end_at
                                              )}`
                                            : ""}
                                          {policy.start_at !== null &&
                                          policy.end_at !== null
                                            ? `You will be charged GBP ${
                                                policy.amount_charge
                                              } if you cancel between ${cancellationDates(
                                                policy.start_at
                                              )} and ${cancellationDates(
                                                policy.end_at
                                              )}`
                                            : ""}
                                          {policy.start_at !== null &&
                                          policy.end_at === null
                                            ? `The room cost is non-refundable if you cancel after ${cancellationDates(
                                                policy.start_at
                                              )}`
                                            : ""}
                                          {policy.start_at === null &&
                                          policy.end_at === null
                                            ? `The room cost is non-refundable`
                                            : ""}
                                        </div>
                                      )
                                    )}
                                  </>
                                }
                              </div>
                            </span>
                          </span>
                        </div>
                      </td>
                      <td className="py-3 px-4">
                        <div className="flex flex-col space-y-1">
                          <a
                            href="#inquire2"
                            onClick={() => handleEnquire(rate)}
                            className={`mt-2 px-4 py-2 rounded-lg text-center ${
                              matchRoom === rate.match_hash
                                ? "bg-halo-pink"
                                : "bg-[#ff3696] hover:bg-halo-pink"
                            } transition-colors text-white`}
                          >
                            {matchRoom === rate.match_hash
                              ? "Selected"
                              : "Select"}
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile View */}
            <div className="block lg:hidden w-full">
              {groupedRates.map((rate, index) => (
                <div
                  key={`deal-mobile-${index}`}
                  className="border-b py-4 px-2 flex flex-col space-y-2"
                >
                  <div>
                    <span className="text-gray-800 font-semibold underline">
                      Meal Plan
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600 font-medium w-3/4">
                      {rate.meal_data.value}
                    </span>
                    <div className="text-sm font-bold text-gray-800 whitespace-nowrap">
                      £ {(parseFloat(rate.payment_options.payment_types[0].amount) * 1.15).toFixed(2)}
                    </div>
                  </div>
                  <div className="flex justify-between items-center">
                    <div className="flex items-center">
                      <span className="text-sm text-green-600">
                        {rate.payment_options.payment_types[0]
                          .cancellation_penalties.free_cancellation_before !=
                        null ? (
                          <span className="flex items-center">
                            {formatCancellationDate(
                              rate.payment_options.payment_types[0]
                                .cancellation_penalties.free_cancellation_before
                            )}
                          </span>
                        ) : (
                          "Non-refundable"
                        )}
                      </span>
                      <span className="relative inline-flex ml-1 group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          fill="currentColor"
                          className="bi bi-info-circle cursor-pointer text-gray-500"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                          <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                        </svg>
                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-[250px] mb-2 hidden group-hover:block p-3 bg-gray-800 text-white text-xs rounded-lg shadow-md text-center">
                          {
                            <>
                              <div>Cancellation Policy</div>
                              {rate.payment_options.payment_types[0].cancellation_penalties.policies.map(
                                (policy, index) => (
                                  <div key={index} className="mt-2">
                                    {policy.start_at === null &&
                                    policy.end_at !== null
                                      ? `Free cancellation at this rate until ${cancellationDates(
                                          policy.end_at
                                        )}`
                                      : ""}
                                    {policy.start_at !== null &&
                                    policy.end_at !== null
                                      ? `You will be charged GBP ${
                                          policy.amount_charge
                                        } if you cancel between ${cancellationDates(
                                          policy.start_at
                                        )} and ${cancellationDates(
                                          policy.end_at
                                        )}`
                                      : ""}
                                    {policy.start_at !== null &&
                                    policy.end_at === null
                                      ? `The room cost is non-refundable if you cancel after ${cancellationDates(
                                          policy.start_at
                                        )}`
                                      : ""}
                                    {policy.start_at === null &&
                                    policy.end_at === null
                                      ? `The room cost is non-refundable`
                                      : ""}
                                  </div>
                                )
                              )}
                            </>
                          }
                        </div>
                      </span>
                    </div>
                    <a
                      href="#inquire"
                      onClick={() => handleEnquire(rate)}
                      className={`mt-2 px-4 py-2 rounded-lg text-center ${
                        matchRoom === rate.match_hash
                          ? "bg-halo-pink"
                          : "bg-[#ff3696] hover:bg-halo-pink"
                      } transition-colors text-white`}
                    >
                      {matchRoom === rate.match_hash ? "Selected" : "Select"}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(RoomsAndPrice);
